// Mock data for Numeros Facil clone

export const siteData = {
  brand: "NF",
  date: "Martes 28 de Abril de 2026",
  title: "Números Fácil | Números Fuertes y Calientes de la Lotería Dominicana",
  heroImage: "https://images.unsplash.com/photo-1518544866330-95a2bec01ed7?w=1600&q=80",
  logo: "https://customer-assets.emergentagent.com/job_numero-builder/artifacts/yhm96yb7_VANDIERE.png",
};

export const navigation = [
  { label: "Números del Día", href: "/#numeros-del-dia" },
  {
    label: "Loterías",
    href: "/#loterias",
    children: [
      { label: "La Primera", href: "/#loterias" },
      { label: "Lotería Real", href: "/#loterias" },
      { label: "New York Día", href: "/#loterias" },
      { label: "Gana Más", href: "/#loterias" },
      { label: "Loteka", href: "/#loterias" },
      { label: "Leidsa", href: "/#loterias" },
      { label: "Lotería Nacional", href: "/#loterias" },
      { label: "New York Noche", href: "/#loterias" },
      { label: "La Suerte", href: "/#loterias" },
    ],
  },
  { label: "Tabla Jaladora", href: "/tabla-jaladora" },
  {
    label: "Numerología",
    href: "/numerologia",
    children: [
      { label: "Método 1220", href: "/numerologia#metodo-1220" },
      { label: "La Cruz de la Suerte", href: "/numerologia#cruz-suerte" },
      { label: "Horóscopo", href: "/numerologia#horoscopo" },
      { label: "Números Inversos", href: "/numerologia#numeros-inversos" },
    ],
  },
  { label: "Sueños", href: "/suenos" },
  { label: "Interpretar Números", href: "/interpretar" },
  { label: "Horas Espejo", href: "/horas-espejo" },
];

export const strongNumbers = [
  { label: "Número Fuerte", value: "0330", color: "from-blue-600 to-blue-800" },
  { label: "Número Caliente", value: "1991", color: "from-orange-500 to-red-600" },
  { label: "Número Extra", value: "3883", color: "from-emerald-500 to-emerald-700" },
];

export const singleStrongNumber = "1991";
export const twoStrongNumber = "0319";
export const recommendedPale = "0319";
export const dailyTriplet = ["03", "19", "38"];
export const vipNumber = "98-89";

export const zodiacSigns = [
  { name: "Aries", symbol: "\u2648", number: 74, dates: "21 Mar - 19 Abr" },
  { name: "Tauro", symbol: "\u2649", number: 59, dates: "20 Abr - 20 May" },
  { name: "Géminis", symbol: "\u264A", number: 43, dates: "21 May - 20 Jun" },
  { name: "Cáncer", symbol: "\u264B", number: 84, dates: "21 Jun - 22 Jul" },
  { name: "Leo", symbol: "\u264C", number: 61, dates: "23 Jul - 22 Ago" },
  { name: "Virgo", symbol: "\u264D", number: 39, dates: "23 Ago - 22 Sep" },
  { name: "Libra", symbol: "\u264E", number: 67, dates: "23 Sep - 22 Oct" },
  { name: "Escorpio", symbol: "\u264F", number: 70, dates: "23 Oct - 21 Nov" },
  { name: "Sagitario", symbol: "\u2650", number: 53, dates: "22 Nov - 21 Dic" },
  { name: "Capricornio", symbol: "\u2651", number: 74, dates: "22 Dic - 19 Ene" },
  { name: "Acuario", symbol: "\u2652", number: 46, dates: "20 Ene - 18 Feb" },
  { name: "Piscis", symbol: "\u2653", number: 35, dates: "19 Feb - 20 Mar" },
];

export const interestLinks = [
  { title: "Método 1220", desc: "Aprende a usar el método 1220 para ganar la lotería", href: "/numerologia#metodo-1220" },
  { title: "La Cruz de la Suerte", desc: "Descubre el método místico para encontrar tus números", href: "/numerologia#cruz-suerte" },
  { title: "Horóscopo", desc: "Tu horóscopo de hoy y números recomendados", href: "/numerologia#horoscopo" },
  { title: "Tabla Jaladora", desc: "Consulta los números que jalan más en la lotería", href: "/tabla-jaladora" },
  { title: "Números Inversos", desc: "Tabla completa de números invertidos", href: "/numerologia#numeros-inversos" },
  { title: "Sueños", desc: "Significado de tus sueños en la quiniela", href: "/suenos" },
];

export const lotteries = [
  "La Primera",
  "Lotería Real",
  "Lotería New York Día",
  "Lotería Gana Más",
  "Lotería Loteka",
  "Lotería Leidsa",
  "Lotería Nacional",
  "Lotería New York Noche",
  "La Suerte",
];

export const recentResults = [
  { name: "Lotería Nacional", numbers: ["24", "58", "73"], time: "21:30" },
  { name: "Lotería Real", numbers: ["08", "19", "42"], time: "12:25" },
  { name: "New York Día", numbers: ["07", "35", "61"], time: "14:30" },
  { name: "New York Noche", numbers: ["12", "49", "88"], time: "22:30" },
  { name: "Leidsa", numbers: ["05", "33", "77"], time: "20:55" },
  { name: "Loteka", numbers: ["15", "41", "69"], time: "19:00" },
];
